import { currentUser } from '../../stores/current_user'
import { Auth } from '../../config/firebase'
import { Agents } from '../database/agents'

Auth.onAuthStateChanged(() => {
  
  if (Auth.currentUser) {
    const userInfo = {
      email: Auth.currentUser.email,
      id: Auth.currentUser.uid,
      phoneNumber: Auth.currentUser.phoneNumber,
      photoUrl: Auth.currentUser.photoUrl
    }

    Agents.findOne(Auth.currentUser.uid)
      .then(doc => {
        if (!!doc) {
          userInfo.agent = doc
          userInfo.agent.id = doc.id
          userInfo.displayName = userInfo.agent.name
          Auth.currentUser.getIdTokenResult()
            .then(idToken => {
              //userInfo.projectIds = idToken.claims.projectIds
              //userInfo.isAdmin = idToken.claims.role === 'admin'
              userInfo.isAdmin = !!idToken.claims.admin
              currentUser.set(userInfo)
            })
            .catch(err => console.log('Claims:', err))
            
          } else {
            currentUser.set(null)
          }
        })
        .catch(err => console.log('User Lookup:', err))

  } else {
    currentUser.set(null)
  } 
})